export default __webpack_public_path__ + "static/SourceSansPro-Bold-12e6acd2589d00c9d0aa9c450dab876b.ttf";